export const apiRoutes = {
  auth: {
    login: "/auth/password-login",
    passwordLessLogin: "/auth/passwordless-login",
    teamLogin: "/auth/team/password-login",
    teamPasswordLessLogin: "/auth/team/passwordless-login",
    changePassword: "/auth/change-password",
    register: "/auth/register",
    registerOrg: "/auth/register-org",
    forgotPassword: "/auth/forgot-password",
    resetPassword: "/auth/reset-password",
    joinOrg: "/auth/join-org",
    verifyOtp: "/auth/verify-otp",
    verifyBusiness: "/auth/verify-business",
    refreshAccessToken: "/auth/refresh-access-token",
    logout: "/auth/logout",
  },
  user: {
    profile: "/users/me",
    update: "/users",
    profileImage: "/users/profile-image",
  },
  events: {
    create: "/events/create",
    myEvents: "/events",
    orgEvents: "/events/organization",
    types: "/events/types",
    mealData: (id: string) => `/events/meal-data/${id}`,
    eventMenu: (id: string) => `/events/menu/${id}`,
    requestEventCancellation: "/events/request-cancellation",
    acceptCancellation: "/events/acknowledge-cancellation",
    directCancellation: "/events/direct-cancellation",
    byId: (id: string) => `/events/${id}`,
    update: (id: string) => `/events/${id}`,
    delete: (id: string) => `/events/${id}/delete`,
  },
  eventRequest: {
    create: "/event-requests/create",
    myRequests: "/event-requests/me",
    orgRequests: "/event-requests/organization",
    approve: (id: string) => `/event-requests/approve/${id}`,
    reject: (id: string) => `/event-requests/reject/${id}`,
    cancel: (id: string) => `/event-requests/cancel/${id}`,
  },
  drink: {
    getAll: "/drink-catalog",
    create: "/drink-catalog/create",
  },
  drinkCategory: {
    getAll: "/drink-catalog/category",
    create: "/drink-catalog/category/create",
  },
  meal: {
    getAll: "/meal-catalog",
    create: "/meal-catalog/create",
    types: "/meal-catalog/types",
  },
  mealCategory: {
    getAll: "/meal-catalog/category",
    create: "/meal-catalog/category/create",
  },
  eventRegistration: {
    register: "/guests/register",
    getEventGuests: (eventId: string) => `/guests/${eventId}`,
  },
  mealPlan: {
    create: "/meal-plan/create",
    getAllMealPlan: "/meal-plan",
    getMealPlan: (id: string) => `/meal-plan/${id}`,
    getEventMealPlan: (eventId: string) => `/meal-plan/event/${eventId}`,
    update: (id: string) => `/meal-plan/${id}/update`,
    updateStatus: (id: string) => `/meal-plan/${id}/status`,
  },
  mealSession: {
    add: (mealPlanId: string) => `/meal-sessions/${mealPlanId}/add`,
    getById: (id: string) => `/meal-sessions/${id}`,
    update: (id: string) => `/meal-sessions/${id}/update`,
    updateStatus: (id: string) => `/meal-sessions/${id}/status`,
  },
  sessionMeal: {
    add: (mealSessionId: string) => `/session-meals/${mealSessionId}/add`,
    addMealPortion: (id: string) => `/meal-session/${id}/add-portions`,
    updateMealPortion: (id: string) => `/meal-session/${id}/portions/update`,
    deleteMealPortion: (id: string, mealPortionId: string) =>
      `/meal-session/${id}/portions/${mealPortionId}`,
    updateStatus: (id: string) => `/session-meals/${id}/status`,
    addRecipes: (id: string) => `/session-meals/${id}/recipes/add`,
    deleteRecipe: (id: string, recipeId: string) =>
      `/session-meals/${id}/recipes/${recipeId}`,
    assignStaff: "/session-meals/assign-staff",
    setGuestServed: (id: string) => `/session-meals/${id}/actual-guests-served`,
  },
  mealRecipe: {
    create: "/meal-recipe/create",
    getAll: "/meal-recipe",
    getById: (id: string) => `/meal-recipe/${id}`,
    update: (id: string) => `/meal-recipe/${id}/update`,
    updateIngredient: (id: string) => `/meal-recipe/ingredients/${id}`,
    delete: (id: string) => `/meal-recipe/${id}/delete`,
  },
  eventGuestDietaryRestriction: (eventId: string) =>
    `/guests/${eventId}/dietary-restrictions`,

  measuringUnits: {
    getAll: "/measuring-units",
    create: "/measuring-units/create",
  },

  ingredients: {
    getAll: "/ingredient-inventories",
    create: "/ingredient-inventories/create",
    getById: (id: string) => `/ingredient-inventories/${id}`,
    update: (id: string) => `/ingredient-inventories/${id}/update`,
    delete: (id: string) => `/ingredient-inventories/${id}/delete`,
    setThreshold: (id: string) => `/ingredient-inventories/${id}/threshold`,
    updateThreshold: (id: string) =>
      `/ingredient-inventories/${id}/threshold/update`,
    addWaste: (id: string) => `/ingredient-inventories/${id}/waste`,
    updateWaste: (id: string) => `/ingredient-inventories/waste/${id}`,
    verifyWasteRecord: (id: string) =>
      `/ingredient-inventories/waste/${id}/verify`,
  },

  drinkInventory: {
    getAll: "/drink-inventory",
    create: "/drink-inventory/create",
    getById: (id: string) => `/drink-inventory/${id}`,
    update: (id: string) => `/drink-inventory/${id}/update`,
    delete: (id: string) => `/drink-inventory/${id}/delete`,
    stockMovement: (id: string) => `/drink-inventory/${id}/stock-movements`,
  },

  mealInventory: {
    getAll: "/meal-inventory",
    create: "/meal-inventory/create",
    getById: (id: string) => `/meal-inventory/${id}`,
    update: (id: string) => `/meal-inventory/${id}/update`,
    delete: (id: string) => `/meal-inventory/${id}/delete`,
    stockMovement: (id: string) => `/meal-inventory/${id}/stock-movements`,
  },

  department: {
    create: "/department/create",
    getAll: "/department",
    getById: (id: string) => `/department/${id}`,
    update: (id: string) => `/department/${id}/update`,
    delete: (id: string) => `/department/${id}/delete`,
  },
  roles: {
    getAll: "/organizations/roles",
    create: "/organizations/roles/create",
    update: (id: string) => `/organizations/roles/${id}/update`,
    delete: (id: string) => `/organizations/roles/${id}/delete`,
  },
  staffs: {
    getAll: "/staffs",
    assignDept: "/staffs/assign-department",
    assignRole: "/staffs/assign-role",
    byId: (staffId: string) => `/staffs/${staffId}`,
    staffProfile: "/staffs/my-staff-profile",
    updateProfile: "/staffs/update",
    getAssignedSession: "/staffs/assigned-session-meals",
  },
} as const;
